export default "__VITE_ASSET__CIXXAfax__"